import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { t } from "i18next";
import LoaderProgressBar from "../../commons/loaderProgressBar";
import { formatCurrencyWithSymbol } from "../../../utils/formatCurrencyWithSymbol";
const CategoryInfo = ({ name, translations, price, currency, loadingData, isSearchCompleted = false, }) => {
    //if the language is not es then show the value text inside translation that has a value language equal to the current language
    let displayname = name;
    // `loadingData` is the authoritative per-category loading flag. The only
    // condition that renders the price is `loadingData === false`; any other
    // value (true, null, undefined) must keep the loader bar visible so we
    // never flash a stale zero while the backend is still streaming data.
    const showLoader = loadingData !== false;
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "category-title", children: displayname }), showLoader ? (_jsx("span", { className: "category-loader category-loader--desktop", children: _jsx(LoaderProgressBar, {}) })) : (_jsxs("span", { className: "category-price", children: [formatCurrencyWithSymbol(t(currency + "_f"), price), "/", t("d")] }))] }));
};
export default CategoryInfo;
